import { useNavigate } from "react-router-dom";
import React from "react";
import "../Style/PhilosophySection.css";
import PhilosophyCover from "../assets/NewPhotos/PhilosofyCoverPhoto.png";
function PhilosophySection() {
  const navigate = useNavigate();
  return (
    <section className="philosophy">
      <div className="philosophy-image-wrap">
        <img
          src={PhilosophyCover}
          className="fade-img"
          alt="Open sketchbook with a hot air balloon drawing and dried flowers"
        />
      </div>

      <div className="philosophy-content">
        <h2 className="philosophy-title">The Philosophy</h2>
        <p className="hero-text">
          There is something magical about a balloon rising into the sky.
          <br />
          It reminds us that growth can be gentle.
        </p>
        <button
          className="hero-btn-primary"
          onClick={() => navigate("our-story")}
        >
          Our Story
        </button>
      </div>
    </section>
  );
}

export default PhilosophySection;
